<template>
    <div class="pb-2" :class="global ? 'border border-gray-300 bg-gray-50 border rounded-lg p-4 m-1 max-w-[400px] my-2 items-center' : ''">
        <div v-if="global" class="flex flex-row justify-between items-center text-slate-700 font-semibold mb-3 px-1">
            <p class="text-sm tracking-wide">Coming Soon</p>
            <i class="fi fi-tr-video-duration text-2xl text-gray-500"></i>
        </div>
        <div class="flex flex-row gap-2 p-2 items-center">
            <SingleToggle
                :active="global ? false : toggleSelectedWebinar"
                :background-color="global ? '#808080' : productCategory.background_color"
                :background-gradient="productCategory.background_gradient"
                :disabled="global"
                @update:active="handleToggle"
            />
            <div>
                <div class="text-xs">
                    {{ $t('payment_additional_webinar') }}
                    <Popper :content="data.slug?.name !== 'altcoin-paket' ? $t('webinar_option_explanation') : $t('webinar_option_explanation_altcoin')">
                        <div class="text-xs flex flex-row gap-1 items-center cursor-pointer">
                            <Icon type="InfoCircle" viewBox="0 0 20 20" width="15" height="15" class="fill-current" />
                        </div>
                    </Popper>
                </div>
                <small
                    v-if="selectedWebinar"
                    :class="[global ? 'hidden' : 'text-xxs rounded-2xl border-2 border-black p-1']"
                    class="text-xxs rounded-2xl border-2 border-black p-1"
                    :style="{ borderColor: productCategory.background_color }"
                >
                    {{ $toCurrency(selectedWebinar?.base_price_gross) }} {{ $t('per_month') }}
                </small>
            </div>
        </div>
    </div>
    {{ data.productVariants }}
</template>

<script setup>
import { computed } from 'vue';

defineProps({
    selectedWebinar: Object,
    data: Object,
    productCategory: Object
});

const emit = defineEmits(['update:toggleSelectedWebinar', 'selectWebinar']);

const toggleSelectedWebinar = defineModel('toggleSelectedWebinar', { type: Boolean });

const handleToggle = (value) => {
    emit('update:toggleSelectedWebinar', value);
    emit('selectWebinar', value);
};

const global = computed(() => {
    return window.meta.region_configuration.region !== 'de';
});
</script>
